import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { Blanket as CompiledBlanket } from './blanket-compiled';
import { Blanket as EmotionBlanket } from './blanket-emotion';
export var Blanket = function Blanket(props) {
  return fg('platform_media_compiled') ? /*#__PURE__*/React.createElement(CompiledBlanket, props) : /*#__PURE__*/React.createElement(EmotionBlanket, props);
};